import { Link } from "react-router-dom";
import { gossipVoices } from "@/mocks/gossipList";

export default function VoiceSection() {
  return (
    <section id="voices" className="w-full bg-background-50" aria-labelledby="voices-title">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-2xl mb-8">
          <p className="flex items-center gap-2 text-xs text-secondary-700 mb-2">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-chat-quote-line"></i>
            </span>
            READERS
          </p>
          <h2 id="voices-title" className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
            读者怎么说
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            我们做的是信息整理这件事，好不好用，最终还是看读的人能不能省下时间。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {gossipVoices.map((v, index) => (
            <figure
              key={v.name}
              className={`flex flex-col gap-4 rounded-lg p-5 border ${
                index === 0
                  ? "bg-accent-50 border-accent-200"
                  : "bg-background-100 border-background-200"
              }`}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-double-quotes-l"></i>
              </span>
              <blockquote className="text-sm md:text-base text-foreground-800 leading-relaxed">{v.text}</blockquote>
              <figcaption className="mt-auto flex items-center gap-2 pt-2 border-t border-background-200">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-800 font-heading font-bold text-sm">
                  {v.name.slice(0, 1)}
                </span>
                <span className="font-heading font-bold text-sm text-foreground-950">{v.name}</span>
                <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">{v.tag}</span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 relative overflow-hidden rounded-lg bg-primary-900">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
            <div className="p-6 md:p-10">
              <h3 className="font-heading font-black text-xl md:text-2xl text-background-50 leading-snug">
                30 条已经整理好，剩下的就是挑一条开始看
              </h3>
              <p className="mt-3 text-sm text-primary-200 leading-relaxed">
                每条都带事件脉络、核心人物和冲突点。看到一半想换个分类，随时可以回到列表重新挑。
              </p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/rankings"
                  className="px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-medium text-center whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
                >
                  进入完整榜单
                </Link>
                <Link
                  to="/contact"
                  className="px-5 py-2.5 rounded-md border border-primary-700 text-primary-100 text-sm text-center whitespace-nowrap hover:bg-primary-800 transition-colors cursor-pointer"
                >
                  我要投稿或纠错
                </Link>
              </div>
            </div>
            <div className="relative w-full h-52 lg:h-full min-h-[220px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20amber%20and%20crimson%20lens%20flare%20over%20a%20dark%20editorial%20texture%20background%20with%20soft%20particles%2C%20cinematic%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=900&height=700&seq=gw-cta-30&orientation=landscape"
                alt="瓜网30大盘点入口 - 暖色光影质感背景"
                title="瓜网30 · 进入完整榜单"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}